import circle from '@turf/circle'
import distance from '@turf/distance'
import { point } from '@turf/helpers'

/**
 * 圆
 * @param {*} coordinates 
 * @param {*} radius 
 * @returns 
 */
export default function (coordinates, radius) {
    if(coordinates.length<2) return [];
    const [center, circle_point] = coordinates;
    let circle_radius;
    if (radius) {
        circle_radius = radius
    } else {
        circle_radius = distance(point(center), point(circle_point));
    }
    return circle(center, circle_radius, { steps: 128 }).geometry.coordinates;
}
